import React from "react";
import Certificate from "../../assets/images/2023-ins-commission-cor.jpg";

const CertificateOfAuthority = () => {
  return (
    <div className='main-container'>
      <img src={Certificate} alt='certificate-of-authority' />
    </div>
  );
};

export default CertificateOfAuthority;
